
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item/[id]",
      function () {
        return require("private-next-pages/item/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/item/[id]"])
      });
    }
  